import { render, staticRenderFns } from "./cmandang_main.vue?vue&type=template&id=2a7d7cfd&scoped=true"
import script from "./cmandang_main.vue?vue&type=script&lang=js"
export * from "./cmandang_main.vue?vue&type=script&lang=js"
import style0 from "./cmandang_main.vue?vue&type=style&index=0&id=2a7d7cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d7cfd",
  null
  
)

export default component.exports